export default __webpack_public_path__ + "static/carousel-4-caa14a512199f83607cd45123362208f.jpg";